import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  constructor() {}

  public navigateWithoutRouting(path: string): void {
    if (window.location.pathname !== path) {
      window.location.href = path;
    }
  }
}
